/**
 * Centralised legal + support links (Item 8 of Estero release).
 * Any UI referring to these URLs must import from here, not inline strings,
 * so future URL changes land in one spot.
 */
export const LEGAL_LINKS = {
  privacyUrl:  "https://apexinfinityventures.com/privacy",
  termsUrl:    "https://apexinfinityventures.com/terms",
  // Delete-account form is hosted inside this app at the public route below.
  // Settings "Request account deletion" opens this URL in the system browser.
  deleteAccountPath: "/fieldproiq/delete-account",
  supportPhone: "407-484-9100",
  supportEmail: "april@apexinfinityventures.com",
};

export const supportTelHref = () => `tel:${LEGAL_LINKS.supportPhone.replace(/[^0-9+]/g, "")}`;
export const supportMailtoHref = () => `mailto:${LEGAL_LINKS.supportEmail}`;
